<div class="flex-column gap-32">
  @if (!editingSection() || editingSection()?.editingPage === MapSettingsPage.MAP_THEMES) {
    <app-map-theme-settings (editing)="onEditClick(MapSettingsPage.MAP_THEMES, $event)">
    </app-map-theme-settings>
  }

  @if (!editingSection() || editingSection()?.editingPage === MapSettingsPage.CUSTOM_LAYERS) {
    <app-custom-layers-config (editing)="onEditClick(MapSettingsPage.CUSTOM_LAYERS, $event)">
    </app-custom-layers-config>
  }
</div>
